<script lang="ts">
  import { onMount } from "svelte";
  import { Capacitor } from "@capacitor/core";
  import {
    dialogTypes,
    getWithJwt,
    resolveMacroGoals,
    serverlessRoutes,
    translate,
    type MacroGoals,
  } from "lib";
  import { activeMealsStore, dialogData, user } from "stores";
  import TopMenu from "../../components/TopMenu.svelte";
  import Macros from "../../components/Diet/Macros.svelte";
  import MealExpansionPanel from "../../components/Diet/MealExpansionPanel.svelte";
  import Spinner from "../../components/UI/Spinner.svelte";
  import { ButtonComponent } from "ui";

  let macrosLatest: MacroGoals | null = null;
  let isLoading = false;

  const fetchMacros = async (): Promise<void> => {
    const url = `${serverlessRoutes.MACRO}?clientId=${$user.id}`;
    try {
      const response = await getWithJwt(url);
      macrosLatest = resolveMacroGoals(response?.data);
    } catch (err) {}
  };

  onMount(async () => {
    isLoading = true;
    await Promise.all([activeMealsStore.fetchData(), fetchMacros()]);
    activeMealsStore.calculateHeadersMacros();
    isLoading = false;
  });

  const onExportToPDF = async (): Promise<void> => {
    const meanPlanId = $activeMealsStore.items[0].mealPlanId;

    $dialogData.data = {
      url: `${serverlessRoutes.MEAL_PLANS}/pdf`,
      entityId: meanPlanId,
      fileName: "meal-plan.pdf"
    };

    $dialogData.type = dialogTypes.PDF_DIALOG;
  };
</script>

<TopMenu entity="DIET" />

<div class="p-4 bg-white dark:bg-zinc-800">
  {#if isLoading}
    <Spinner />
  {:else}
    {#if macrosLatest}
      <div class="mb-4 p-2 border rounded-md border-slate-200 dark:border-zinc-600 text-center">
        <div class="mb-4">
          {translate("SUGGESTED_MACROS")}
          <span class="text-amber-400">{macrosLatest.calories}</span>
          kcal
        </div>
        <Macros
          carbs={macrosLatest.carbs}
          fats={macrosLatest.fats}
          calories={macrosLatest.calories}
          protein={macrosLatest.protein}
          isBarVisible
        />
      </div>
    {/if}
    {#if $activeMealsStore.items.length > 0}
      <div class="flex justify-center">
        <ButtonComponent
          myClasses="m-4"
          on:click={onExportToPDF}>
          {translate("EXPORT_TO_PDF")}
        </ButtonComponent>
      </div>
    {/if}
    <div class="flex flex-col gap-4">
      {#each $activeMealsStore.items as meal}
        <MealExpansionPanel isCommentable {meal} />
      {/each}

      {#if Capacitor.getPlatform() === "ios"}
        <div class="mb-1"></div>
      {/if}
    </div>
  {/if}
  {#if Capacitor.isNativePlatform()}
    <div class="mb-12"></div>
  {/if}
</div>
